"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveConstantValueBindingCallback = resolveConstantValueBindingCallback;
function resolveConstantValueBindingCallback(_params, binding) {
    return binding.value;
}
//# sourceMappingURL=resolveConstantValueBindingCallback.js.map